import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import Delo from "../../img/delo.svg";
import Mmr from "../../img/mmr.svg";
import Top from "../../img/top100.svg";
import Womo from "../../img/womo.svg";
import Ekonomika from "../../img/Logo_Ekonomika.svg";
import Podsolnuh from "../../img/podsoln.png";
import PodsolnuhSm from "../../img/podsoln-sm.png";


import Get from "../../img/get.png";
import Hrws from "../../img/hrws.png";
import Prmrfn from "../../img/prmrfn.png";
import Bws from "../../img/bws.png";
import Mrktng from "../../img/mrktng.png";

import 'animate.css';


const EventOrganizers = () => {
    return (
      <section className="relative py-[60px] bg-[#F6EAE8]">

        <div className="container overflow-hidden md:overflow-visible  mx-auto lg:max-w-[1075px] mb-8 px-5">

            <div className="relative mb-10 px-5 md:mb-20">
                <ScrollAnimation animateIn="animate__fadeInUp">
                    <h2 className="text-3xl sm:text-4xl mb-9 md:mb-16 uppercase text-center">Організатори</h2>
                </ScrollAnimation>
        
                <div className="relative z-10 flex justify-center gap-4 md:justify-between">
                    {/* DELO */}
                    <a href="https://delo.ua" target="_blank" rel="noopener noreferrer"
                    className="relative flex flex-1 items-center justify-center text-center bg-[#A0D778] rounded-[3px] px-[15px] w-full max-w-[127px] lg:max-w-[246px] lg:min-h-[106px] lg:justify-start">
                    <p className="text-[9px] leading-[130%] z-10 max-w-full md:text-[11px] md:text-left lg:text-[16px] lg:max-w-[150px]">
                        лідер ділового контенту Delo.ua
                    </p>
                    <span className="absolute z-10 w-[73px] h-[73px] bg-[#FA6C97] rounded-full flex items-center justify-center top-[30px] -left-[40px] md:-top-[10px] md:left-auto md:-right-[55px] lg:w-[120px] lg:h-[120px]">
                        <img src={Delo} alt="delo" className="w-[60%]" />
                    </span>
                    <span className="absolute w-[81px] h-[81px] rounded-full border-2 border-[#f65f8c] top-[26px] -left-[44px] md:-top-[14px] md:left-auto md:-right-[59px] lg:w-[128px] lg:h-[128px]" />
                    <span className="absolute w-[60px] h-[18px] -bottom-[63px] left-0 md:w-[110px] md:h-[23px] md:left-[125%] md:bottom-[15px] lg:w-[175px] lg:h-[53px] lg:left-[80%]">
                        <svg viewBox="0 0 154 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M153 34L120 1H0" stroke="#FA6C97" strokeWidth="2" strokeDasharray="10 10" />
                        </svg>
                    </span>
                    </a>
        
                    {/* MMR */}
                    <a href="https://mmr.ua" target="_blank" rel="noopener noreferrer"
                    className="relative flex flex-1 items-center justify-center text-center bg-[#A0D778] rounded-[3px] px-[15px] w-full max-w-[127px] min-h-[58px] lg:max-w-[246px] lg:min-h-[106px] lg:justify-end">
                    <p className="text-[9px] leading-[130%] z-10 max-w-full md:text-[11px] md:text-right lg:text-[16px] lg:max-w-[150px]">
                        онлайн-медіа про PR та маркетинг MMR.ua
                    </p>
                    <span className="absolute z-10 w-[73px] h-[73px] bg-[#FA6C97] rounded-full flex items-center justify-center top-[34px] -right-[40px] md:-top-[10px] md:right-auto md:-left-[55px] lg:w-[120px] lg:h-[120px]">
                        <img src={Mmr} alt="mmr" className="w-[60%]" />
                    </span>
                    <span className="absolute w-[81px] h-[81px] rounded-full border-2 border-[#f65f8c] top-[30px] -right-[44px] md:-top-[14px] md:right-auto md:-left-[59px] lg:w-[128px] lg:h-[128px]" />
                    <span className="absolute w-[60px] h-[18px] -bottom-[64px] right-0 md:w-[110px] md:h-[23px] md:right-[125%] md:bottom-[15px] lg:w-[175px] lg:h-[53px] lg:right-[80%]">
                        <svg viewBox="0 0 154 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 34L34 1H154" stroke="#FA6C97" strokeWidth="2" strokeDasharray="10 10" />
                        </svg>
                    </span>
                    </a>
                </div>
        
                {/* CENTER BLOCK */}
                <div className="relative flex justify-center py-[25px] md:py-0 md:my-[-50px]">
                    <img src={Podsolnuh} alt="Image" className="absolute bottom-[75px] sm:-bottom-[10px] lg:bottom-[30px] left-1/2 -translate-x-1/2 w-[275px] sm:w-[450px] lg:w-[575px]" />
                    <a href="https://ekonomika.ua/" target="_blank" rel="noopener noreferrer"
                    className="relative flex shrink-0 flex-col items-center justify-center gap-[10px] md:gap-[20px] w-[162px] h-[162px] md:w-[210px] md:h-[210px] lg:w-[289px] lg:h-[289px] rounded-full bg-[#8BD17B] text-center">
                    <img src={Ekonomika} alt="Ekonomika+" className="w-[120px] md:w-auto" />
                    <p className="text-[10px] md:text-[20px] leading-[130%] text-balance">бізнес/медіа бюро, до якого входять:</p>
                    {[['top-[25px]', '-left-[3px]', 'left-0'], ['top-[25px]', '-right-[3px]', 'right-0'], ['bottom-[25px]', '-left-[3px]', 'left-0'], ['bottom-[25px]', '-right-[3px]', 'right-0']].map(([pos, shift, reset], i) => (
                        <span key={i} className={`absolute z-10 w-[18px] h-[18px] lg:w-[33px] lg:h-[33px] bg-[#FA6C97] border-[2.5px] md:border-[5px] border-white rounded-full ${pos} ${shift} md:${reset}`} />
                    ))}
                    <span className="absolute w-[175px] h-[175px] md:w-[240px] md:h-[240px] lg:w-[319px] lg:h-[319px] rounded-full border-2 border-[#f65f8c]" />
                    <img src={PodsolnuhSm} alt="Image" className="absolute z-20 w-[75px] bottom-0 -right-[35px] md:-bottom-[20px] md:w-[105px] lg:w-[155px] md:-right-[65px]" />
                    </a>
                </div>
        
                {/* BOTTOM */}
                <div className="relative z-10 flex justify-center gap-4 md:justify-between">
                    {/* TOP 100 */}
                    <a href="https://delo.ua/top100" target="_blank" rel="noopener noreferrer"
                    className="relative flex flex-1 items-center justify-center text-center bg-[#A0D778] rounded-[3px] px-[15px] w-full max-w-[127px] min-h-[58px] lg:justify-start lg:max-w-[246px] lg:min-h-[106px]">
                    <p className="text-[9px] leading-[130%] z-10 max-w-full md:text-[11px] md:text-left lg:text-[16px] lg:max-w-[150px]">
                        журнал «ТОП-100. Рейтинги найбільших»
                    </p>
                    <span className="absolute z-10 w-[73px] h-[73px] bg-[#FA6C97] rounded-full flex items-center justify-center bottom-[35px] -left-[40px] md:-bottom-[7px] md:left-auto md:-right-[55px] lg:w-[120px] lg:h-[120px]">
                        <img src={Top} alt="top100" className="w-[60%]" />
                    </span>
                    <span className="absolute w-[81px] h-[81px] rounded-full border-2 border-[#f65f8c] bottom-[31px] -left-[44px] md:-bottom-[11px] md:left-auto md:-right-[59px] lg:w-[128px] lg:h-[128px]" />
                    <span className="absolute w-[60px] h-[18px] -top-[60px] left-0 md:w-[110px] md:h-[23px] md:left-[125%] md:top-[15px] lg:w-[175px] lg:h-[53px] lg:left-[80%] lg:top-[25px]">
                        <svg viewBox="0 0 154 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M153 1L120 34H0" stroke="#FA6C97" strokeWidth="2" strokeDasharray="10 10" />
                        </svg>
                    </span>
                    </a>
        
                    {/* WOMO */}
                    <a href="https://womo.ua" target="_blank" rel="noopener noreferrer"
                    className="relative flex flex-1 items-center justify-center text-center bg-[#A0D778] rounded-[3px] px-[15px] w-full max-w-[127px] min-h-[58px] lg:justify-end lg:max-w-[246px] lg:min-h-[106px]">
                    <p className="text-[9px] leading-[130%] z-10 max-w-full md:text-[11px] md:text-right lg:text-[16px] lg:max-w-[150px]">
                        дайджест ділової жінки Womo.ua
                    </p>
                    <span className="absolute z-10 w-[73px] h-[73px] bg-[#FA6C97] rounded-full flex items-center justify-center bottom-[35px] -right-[40px] md:-bottom-[7px] md:right-auto md:-left-[55px] lg:w-[120px] lg:h-[120px]">
                        <img src={Womo} alt="womo" className="w-[60%]" />
                    </span>
                    <span className="absolute w-[81px] h-[81px] rounded-full border-2 border-[#f65f8c] bottom-[31px] -right-[44px] md:-bottom-[11px] md:right-auto md:-left-[59px] lg:w-[128px] lg:h-[128px]" />
                    <span className="absolute w-[60px] h-[18px] -top-[60px] right-0 md:w-[110px] md:h-[23px] md:right-[125%] md:top-[15px] lg:w-[175px] lg:h-[53px] lg:right-[80%] lg:top-[25px]">
                        <svg viewBox="0 0 154 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L34 34H154" stroke="#FA6C97" strokeWidth="2" strokeDasharray="10 10" />
                        </svg>
                    </span>
                    </a>
                </div>
            </div>

            <ScrollAnimation animateIn="animate__fadeInUp">
            <h3 className="text-[18px] leading-[130%] font-semibold mb-[30px] md:text-[24px] md:mb-[50px]">
                Компанія щорічно проводить майже 20 бізнес-заходів, серед яких:
            </h3>
            </ScrollAnimation>
            <ScrollAnimation animateIn="animate__fadeInUp">
            <div className="mb-[40px] md:mb-9 grid md:grid-cols-2 gap-y-[30px] md:gap-x-[50px]">
                <a href="https://get.delo.ua/" className="flex items-center gap-[16px]">
                    <img src={Get} alt="Image" className="w-[73px] shrink-0 md:w-[86px]" />
                    <p className="font-light">
                    Get Business Festival: великий фестиваль для малого та середнього бізнесу
                    </p>
                </a>

                <a href="https://hrws.delo.ua/" className="flex items-center gap-[16px]">
                    <img src={Hrws} alt="Image" className="w-[73px] shrink-0 md:w-[86px]" />
                    <p className="font-light">
                    HR Wisdom Summit: трансформація робочого середовища у місце сили та зростання
                    </p>
                </a>

                <a href="https://prmrfn.mmr.ua/" className="flex items-center gap-[16px]">
                    <img src={Prmrfn} alt="Image" className="w-[73px] shrink-0 md:w-[86px]" />
                    <p className="font-light">PR-марафон: огляд трендів у PR-галузі</p>
                </a>

                <a href="https://bws.delo.ua/" className="flex items-center gap-[16px]">
                    <img src={Bws} alt="Image" className="w-[73px] shrink-0 md:w-[86px]" />
                    <p className="font-light">
                    Business Wisdom Summit: стратегії та досвід змін від лідерів великого бізнесу
                    </p>
                </a>

                <a href="https://mrktng.mmr.ua/" className="flex items-center gap-[16px]">
                    <img src={Mrktng} alt="Image" className="w-[73px] shrink-0 md:w-[86px]" />
                    <p className="font-light">MRKTNG MRTH: брендинг надможливостей</p>
                </a>
            </div>
            </ScrollAnimation>
            <ScrollAnimation animateIn="animate__fadeInUp">
            <p className="mb-4 md:mb-7 md:text-[18px]">Marketing Media Review — чесне, гостре та динамічне медіа про маркетинг, комунікації та креатив.
                Це медіа для тих, хто не просто стежить за ринком, а й формує його. MMR розповідає про тренди та новини ринку, аналізує успішні й провальні рекламні кампанії, ставить незручні запитання найкращим фахівцям ринку та копає глибше, ніж дно маркетингового бюджету.</p>
            </ScrollAnimation>
        </div>
        
      </section>
    );
  };
  

export default EventOrganizers;
